import { useCallback, useState } from "react";
import { DeptItem, OperationEvent } from "../type";
import { useDeptList } from "@/hooks/services";

export function useDeptSelectorModal() {
  const [eventType, setEventType] = useState<OperationEvent>("search");
  const [selectedDept, setSelectedDept] = useState<DeptItem | null>(null);
  const [searchValue, setSearchValue] = useState("");

  const { list: searchList } = useDeptList(searchValue);
  const searchedDepts = searchList.map((i) => ({
    deptNo: i.deptNo,
    deptName: i.deptName,
  }));

  const reset = useCallback(() => {
    setSelectedDept(null);
    setSearchValue("");
    setEventType("search");
  }, []);

  const handleSearch = (value: string) => {
    setSearchValue(value);
    setSelectedDept(null);
    setEventType("search");
  };

  return {
    selectedDept,
    searchValue,
    searchedDepts,
    reset,
    setSelectedDept,
    setSearchValue,
    handleSearch,
    eventType,
    setEventType,
  };
}
